import { openDB } from "idb";
import { SESSION_TIMEOUT_SECONDS } from "../constants";
const formsDbName = "forms-state";
const formsStoreName = "forms";
export const getFormsDb = async () => {
    const db = await openDB(formsDbName, 1, {
        upgrade(db) {
            if (!db.objectStoreNames.contains(formsStoreName)) {
                db.createObjectStore(formsStoreName, { keyPath: "id" });
            }
        },
    });
    return db;
};
export const saveFormState = async (sessionId, data) => {
    const db = await getFormsDb();
    const item = {
        id: sessionId,
        data: JSON.stringify(data),
        expiry: Date.now() + SESSION_TIMEOUT_SECONDS * 1000, // in milliseconds
    };
    await db.put(formsStoreName, item);
};
export const getFormState = async (sessionId) => {
    const db = await getFormsDb();
    const item = (await db.get(formsStoreName, sessionId));
    if (!item) {
        return undefined;
    }
    if (Date.now() > item.expiry) {
        await db.delete(formsStoreName, sessionId);
    }
    return JSON.parse(item.data);
};
export const clearFormState = async (sessionId) => {
    const db = await getFormsDb();
    console.log("DB", db, await getFormState(sessionId));
    await db.delete(formsStoreName, sessionId);
};
//# sourceMappingURL=storageService.js.map